import * as React from 'react'
import TagBadge from '../../../shared/tags/badge'
import { Tag, ElementItem } from './types'

const { I18n } = window as any

type ElementTableProps = {
  items: ElementItem[]
  selectedIds: Set<string | number>
  onToggleOne: (id: string | number) => void
  onToggleAll: () => void
  allSelected: boolean
  showImages?: boolean
}

export default function ElementTable(props: ElementTableProps) {
  const { items, selectedIds, onToggleOne, onToggleAll, allSelected, showImages } = props

  return (
    <div style={{ maxHeight: 'calc(90vh - 200px)', overflowY: 'auto' }}>
      <table className="table table-bordered table-hover table-striped table-sm">
        <thead>
          <tr>
            <th style={{ width: '40px' }}>
              <input
                type="checkbox"
                checked={allSelected}
                onChange={onToggleAll}
                disabled={items.length === 0}
              />
            </th>
            {showImages && <th style={{ width: '160px' }}>{I18n.t('activerecord.attributes.elements/base_element.photo')}</th>}
            <th>{I18n.t('activerecord.attributes.elements/base_element.name')}</th>
            <th>{I18n.t('activerecord.attributes.elements/base_element.sku')}</th>
            <th className="text-left">{I18n.t('activerecord.models.tag.other')}</th>
          </tr>
        </thead>
        <tbody>
          {items.length === 0 ? (
            <tr>
              <td colSpan={showImages ? 5 : 4} className="text-center text-muted">
                {I18n.t('application.empty_list')}
              </td>
            </tr>
          ) : (
            items.map((item) => (
              <tr key={item.value}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedIds.has(item.value)}
                    onChange={() => onToggleOne(item.value)}
                  />
                </td>
                {showImages && (
                  <td>
                    {item.photoUncuttedThumb && (
                      <img
                        src={item.photoUncuttedThumb}
                        alt=""
                        style={{ maxHeight: '150px', maxWidth: '150px' }}
                      />
                    )}
                  </td>
                )}
                <td>{item.name || item.label}</td>
                <td>{item.sku || ''}</td>
                <td className="text-left">
                  {(item.tags || []).map((tag) => (
                    <TagBadge key={tag.value} type={tag.type} name={tag.label} />
                  ))}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}
